import React from 'react';
import { Box, Typography, keyframes } from '@mui/material';
import { grey, blue } from '@mui/material/colors';
import { useThemeContext } from '../../context/ThemeContext';

// Define keyframes for the bouncing dots
const bounce = keyframes`
  0%, 80%, 100% { 
    transform: translateY(0);
  }
  40% { 
    transform: translateY(-5px);
  }
`;

const TypingIndicator: React.FC = () => {
  const { mode } = useThemeContext();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        mt: 1,
        mb: 2,
        ml: 7 // Align with avatar in other messages
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: mode === 'dark' ? '#1a2635' : grey[100],
          px: 2,
          py: 1,
          borderRadius: 2,
          maxWidth: '100px',
          border: mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
          boxShadow: mode === 'dark' ? '0 2px 8px rgba(0, 0, 0, 0.2)' : 'none'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: mode === 'dark' ? blue[400] : grey[500],
              mx: 0.5,
              animation: `${bounce} 1s infinite ease-in-out`,
              animationDelay: '0s'
            }}
          />
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: mode === 'dark' ? blue[400] : grey[500],
              mx: 0.5,
              animation: `${bounce} 1s infinite ease-in-out`,
              animationDelay: '0.1s'
            }}
          />
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: mode === 'dark' ? blue[400] : grey[500],
              mx: 0.5,
              animation: `${bounce} 1s infinite ease-in-out`,
              animationDelay: '0.2s'
            }}
          />
        </Box>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1 }}>
        Support Team is typing...
      </Typography>
    </Box>
  );
};

export default TypingIndicator;